import { render, staticRenderFns } from "./PersonalReferenceData.vue?vue&type=template&id=01b5c9e3&scoped=true&"
import script from "./PersonalReferenceData.vue?vue&type=script&lang=js&"
export * from "./PersonalReferenceData.vue?vue&type=script&lang=js&"
import style0 from "./PersonalReferenceData.vue?vue&type=style&index=0&id=01b5c9e3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b5c9e3",
  null
  
)

export default component.exports